import { Component, Input, OnInit } from '@angular/core';
import { CheckboxControlValueAccessor, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { dataService } from '../../../../shared/services/data.service';
import { OTPService } from '../../../../shared/services/otp-table';

@Component({
  selector: 'app-modify-user',
  templateUrl: './modify-user.component.html',
  styleUrls: ['./modify-user.component.scss']
})
export class ModifyUserComponent implements OnInit {
  public userForm: FormGroup; 
  public isloggedin=false; 
  public currentuser: User;
  public user: User;
  public codeValue: string;
  public secteurValue: string;
  public roleValue: string;
  public imagePreview:string
  private usersSub: Subscription;
  public loading = false;
  public optionValue:any;
  public option1Value:any;
  public option2Value:any;
  public option3Value:any;
  public submitted=false;
  fiscalmatPattern = "^[0-9]{7}$";
  fiscalmatletterPattern="^[A-Z]{1}$";
  fiscalmatnumbersPattern="^[0-9]{3}$";
  codepostalPattern: "^[a-zA-Z0-9]+{4}$"

  errormsg:string;
  activites: any[]=["Médecin","Avocat","Consultant","Expert","Infirmier","Masseur","Physiothérapeute","Ergothérapeute","Psychomotricien",
  "Diététicien","Orthophoniste","Orthoptiste","Sage-femmes","Architectes","Dessinateurs","Géomètres","Notaire","Huissiers notaire (de justice)", "Interprètes",
  "Ingénieurs-conseil","Topographes","Syndic des copropriétaires","Autre"];
  sousactivites: any[]=["Avocat","Avocat à la cour d'appel","Avocat à la cour de cassation","Médecin","Médecin spécialiste","Médecin dentiste","Médecin vétérinaire"];
  specialites: any[]=["Chirurgie générale",
  "Chirurgie pédiatrique",
  "Chirurgie carcinologique",
  "Chirurgie cardio-vasculaire",
  "Chirurgie vasculaire périphérique",
  "Chirurgie neurologique",
  "Chirurgie orthopédique et traumatologique",
  "Chirurgie plastique, réparatrice et esthétique",
  "Chirurgie urologique",
  "Gynéco-obstétrique",
  "ORL",
  "Stomatologie et chirurgie maxillo-faciale",
  "Ophtalmologie",
  "Chirurgie thoracique",
  "Anesthésie réanimation",
  "Psychiatrie",
  "Pédo-psychiatrie",
  "Imagerie médicale",
  "Anatomie",
  "Anatomie et cytologie pathologiques",
  "Carcinologie médicale",
  "Cardiologie",
  "Dermatologie",
  "Endocrinologie",
  "Gastro-entérologie",
  "Hématologie clinique",
  "Maladies infectieuses",
  "Médecine d’urgence",
  "Médecine de travail",
  "Médecine interne",
  "Médecine légale",
  "Médecine physique, rééducation et réadaptation fonctionnelle",
  "Médecine préventive et communautaire",
  "Néphrologie",
  "Neurologie",
  "Nutrition et maladies nutritionnelles",
  "Pédiatrie",
  "Pneumologie",
  "Radiothérapie carcinologique",
  "Réanimation médicale",
  "Rhumatologie",
  "Biophysique et médecine nucléaire",
  "Génétique",
  "Biologie médicale option biochimie",
  "Biologie médicale option hématologie",
  "Biologie médicale option parasitologie",
  "Biologie médicale option microbiologie",
  "Biologie médicale option immunologie",
  "Histo-embryologie",
  "Pharmacologie",
  "Physiologie et explorations fonctionnelles"];
  sousspecialites: any[]=[];
  sousactivitesavocat: string[]=["Avocat","Avocat à la cour d'appel","Avocat à la cour de cassation"];
  sousactivitesmedecin: string[]=["Médecin","Médecin spécialiste","Médecin dentiste","Médecin vétérinaire"];
  specialitesmedecinspecialiste: string[]=["Chirurgie générale",
  "Chirurgie pédiatrique",
  "Chirurgie carcinologique",
  "Chirurgie cardio-vasculaire",
  "Chirurgie vasculaire périphérique",
  "Chirurgie neurologique",
  "Chirurgie orthopédique et traumatologique",
  "Chirurgie plastique, réparatrice et esthétique",
  "Chirurgie urologique",
  "Gynéco-obstétrique",
  "ORL",
  "Stomatologie et chirurgie maxillo-faciale",
  "Ophtalmologie",
  "Chirurgie thoracique",
  "Anesthésie réanimation",
  "Psychiatrie",
  "Pédo-psychiatrie",
  "Imagerie médicale",
  "Anatomie",
  "Anatomie et cytologie pathologiques",
  "Carcinologie médicale",
  "Cardiologie",
  "Dermatologie",
  "Endocrinologie",
  "Gastro-entérologie",
  "Hématologie clinique",
  "Maladies infectieuses",
  "Médecine d’urgence",
  "Médecine de travail",
  "Médecine interne",
  "Médecine légale",
  "Médecine physique, rééducation et réadaptation fonctionnelle",
  "Médecine préventive et communautaire",
  "Néphrologie",
  "Neurologie",
  "Nutrition et maladies nutritionnelles",
  "Pédiatrie",
  "Pneumologie",
  "Radiothérapie carcinologique",
  "Réanimation médicale",
  "Rhumatologie",
  "Biophysique et médecine nucléaire",
  "Génétique",
  "Biologie médicale option biochimie",
  "Biologie médicale option hématologie",
  "Biologie médicale option parasitologie",
  "Biologie médicale option microbiologie",
  "Biologie médicale option immunologie",
  "Histo-embryologie",
  "Pharmacologie",
  "Physiologie et explorations fonctionnelles"];
  selected: any;
  activitesassociation: string[];
  activitesassociations: any[]=["Syndic des copropriétaires"];
  activitesliberales: string[]=["Médecin","Avocat","Consultant","Expert","Infirmier","Masseur","Physiothérapeute","Ergothérapeute","Psychomotricien",
  "Diététicien","Orthophoniste","Orthoptiste","Sage-femmes","Architectes","Dessinateurs","Géomètres","Notaire","Huissiers notaire (de justice)", "Interprètes",
  "Ingénieurs-conseil","Topographes","Autre"];
  uploadFiles: File[];
  @Input() possibleroles:string[]=[]
  processing: boolean;
  showpassword: boolean=false;
  constructor(private formBuilder: FormBuilder,
   
    private userservice: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private otp: OTPService,
    private data: dataService,
    private tokenStorage: TokenStorageService,
   ) {}

  ngOnInit() {
    this.loading = true;

    if(this.router.url.includes('change-password'))
    {
this.showpassword=true
    }
     if (this.tokenStorage.getToken()){
      this.isloggedin=true;
      this.currentuser =this.tokenStorage.getUser()
      console.log(this.router)
      this.route.params.subscribe(
        (params) => {
          this.userservice.getUserById(params.id).then(
            (user: User) => {
              this.loading = false;
              this.user = user;
                this.userForm = this.formBuilder.group({
                  role: [this.user.role,],
                  firstname: [this.user.firstname,],
                  lastname: [this.user.lastname,],
                  confirmemail: [null],
                  mobile: [this.user.mobile,],
                  confirmmobile: [null],
                  usertype: [this.user.usertype,],
                  email: [this.user.email,],
                  password: [null,],
                  confirmpassword: [null,],
                  civilite: [this.user.civilite,],
                  nature: [this.user.nature,],
                  raisonsociale: [this.user.raisonsociale,],
                  image: [this.user.ficheUrl||'',],
                  selectactivitynature: [null,],
                  selectactivity:[null,],
                  selectunderactivity:[null,],
                  selectfiscalimpot:[null,],
                  fiscaltvaassobli: [{value:"Assujeti Obligatoire",disabled:true}],
                  fiscalmat:/*this.user.natureactivite? [this.user.matriculefiscale,[Validators.pattern(this.fiscalmatPattern),Validators.required]]:
                  */
                 [this.user.matriculefiscale],
                  fiscalmatletter:/*this.user.natureactivite? [null,[Validators.pattern(this.fiscalmatletterPattern),Validators.maxLength(1),Validators.required]]:
                  */[null],
                  fiscalmatinchanged: ["A"],
                  fiscalmatinchanged2: ["P"],
                  fiscalmatnumbers:/*this.user.natureactivite? ["000",[Validators.pattern(this.fiscalmatnumbersPattern),Validators.maxLength(3),Validators.required]]:
                  */["000"],
                  clientcode: [{value:this.user.clientcode,disabled:true}],
                  terminal: [this.user.terminal,],
                  affiliation: [this.user.affiliation,],
                  carte: [this.user.carte,],
                  compte: [this.user.compte,],
                  banque: [this.user.banque,],
                  indicatifagence: [this.user.indicatifagence,],
                },
                )
              
              this.loading = false;
              
            }
          )
        }
      )
}
            
            else {this.router.navigate(['auth/login'])};
           
            
           
           
          }   
          get f() { return this.userForm.controls; } 
  onSubmit() {
    this.loading = true;
    this.submitted = true;
    if (this.userForm.invalid) {
      
     return this.loading = false;
  }
    const user = new User();
    user.userId = this.currentuser.userId;
    user.role = this.userForm.get('role').value;
    user.email = this.userForm.get('email').value;
    user.password =this.userForm.get('password').value;
    user.mobile = this.userForm.get('mobile').value;
    user.usertype =this.userForm.get('usertype').value;
    user.confirmpassword =this.userForm.get('confirmpassword').value;
    user.firstname = this.userForm.get('firstname').value;
    user.lastname = this.userForm.get('lastname').value;
    user.ficheUrl=''
    user.civilite = this.userForm.get('civilite').value;
    user.clientcode = this.userForm.get('clientcode').value;
    user.banque = this.userForm.get('banque').value;
    user.compte = this.userForm.get('compte').value;
    user.carte = this.userForm.get('carte').value;
    user.affiliation = this.userForm.get('affiliation').value;
    user.terminal = this.userForm.get('terminal').value;
    console.log(user)
    this.userservice.modifyUserById(this.user._id, user).then(  
      () => {
     //  this.userForm.reset();
        this.loading = false;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Modification réalisée avec succès!',
          showConfirmButton: false,
          
        });
        /*this.alertService.success('Modification effectuée avec succès!', { keepAfterRouteChange: true });
        window.scrollTo(0, 0);
        this.router.navigate(['profil'])*/
      },
      (error) => {
        this.loading = false
      }
    );
  }
  controllength(datavalue:FormControl,e:any)
  {
    let name=e.target.getAttribute('formControlName')
    console.log(name,datavalue.value.length)
    name=='carte'&&datavalue.value.length==16||name=='compte'&&datavalue.value.length==20?this.userservice.getuserbydata(datavalue.value).then(
      (data:any)=>{
        console.log(data)
        if (data.length>0) {
          return alert(name=='carte'?'carte déjà utilisée par un autre porteur':'compte déjà utilisée par un autre porteur')
        } 
        else
        {
          name=='carte'&&datavalue.value.length==16?this.onvalue(datavalue,e):
          name=='compte'&&datavalue.value.length==20?this.onvalue(datavalue,e):''
        }       
      }  
    ):''
  }
  onvalue(datavalue:FormControl,e:any)
  {
    console.log(datavalue)
    this.processing=true
    let name=e.target.getAttribute('formControlName')
    this.data.getinfo(datavalue.value).then(
      (data:any)=>{
        this.processing=false
        console.log(data)
        console.log(this.userForm.get('mobile').value,'this the mobile number')
        if(data.length>0)
        {
          this.otp.createwithoutfile(this.user._id,this.userForm.get('mobile').value,this.userForm.get('email').value).then(
            async (res:any)=>{
this.processing=true
              const { value: numero } = await Swal.fire({
                title: 'Résultat',
                html: 'Veuillez saisir le code envoyé par sms, il va être expiré après 1 minute',
                input: 'text',
                inputLabel: 'numéro',
                inputValue: '',
                showCancelButton: true,
                inputValidator: (value) => {
                  if (!value) {
                    return 'Vous devez renseigner une valeur!'
                  }
                }
              })
              this.otp.validateotp(numero).then(
                (success:any) => {
               name=='compte'?  (this.processing=false,Swal.fire({
                    title: 'otp valide',
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                  }).then((result) => {
                    this.userForm.patchValue(
                      {
                        carte:data[0].carte
                      }
                    )  
                  }).catch(() => {
                    Swal.fire('opération non aboutie!')
                  })):
                  (this.processing=false, Swal.fire({
                    title: 'otp valide',
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                  }).then((result) => {
                    this.userForm.patchValue(
                      {
                        compte:data[0].compte
                      }
                    )  
                  }).catch(() => {
                    Swal.fire('opération non aboutie!')
                  }))
                        },
                (error)=> {
                  Swal.fire({
                    title: 'otp erroné',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                  }).then((result) => {datavalue.reset(),this.processing=false
                  }).catch(() => {
                    Swal.fire('opération non aboutie!')
                  })
                }
              )
            }
          )
        }
         else
         {
          Swal.fire({
            title: 'données introduits introuvable ',
            icon: 'error',
            confirmButtonColor: '#3085d6',
          }).then((result) => {datavalue.reset(),this.processing=false
          }).catch(() => {
            Swal.fire('opération non aboutie!')
          })
         }    
      }
    )

  }
 /* update0(e)
  {

    this.selected = e.target.value
    if(this.userForm.get('activitynature').value=='Profession Libérale')
{
  this.userForm.patchValue({
    fiscalmatinchanged:'A',
    fiscalmatinchanged2:'P',
    fiscalmatnumbers:'000'
  })
}
    if(this.selected=='associations et syndics')
    {
this.activites=this.activitesassociations
    }
    else if (this.selected=='Profession Libérale')
    {
      this.activites=this.activitesliberales
    }
    else{
      this.activites=[]
    }
    this.userForm.patchValue({
      activity:'',
      selectactivity:'',
      underactivity:'',
      selectunderactivity:'',
      specialite: '',
      sousspecialite: '',
    })
  }
  update(e)
  {
    this.selected = e.target.value
    if(this.userForm.get('activity').value=='Syndic des copropriétaires')
{
  console.log('here')
  this.userForm.patchValue({
    fiscalmatinchanged:'N',
    fiscalmatinchanged2:'N',
    fiscalmatnumbers:'000'
  })
}
    if(this.selected=='Avocat')
    {
this.sousactivites=this.sousactivitesavocat
    }
    else if (this.selected=='Médecin')
    {
      this.sousactivites=this.sousactivitesmedecin

    }
    else{
      this.sousactivites=[]
      this.specialites=[]
      this.sousspecialites=[]
    }
    this.userForm.patchValue({
      
      underactivity:'',
      selectunderactivity:'',
      specialite: '',
      sousspecialite: '',
    })
  }
  update2(e)
  {
    this.selected = e.target.value
    
    if(this.selected=='Médecin spécialiste')
    {
this.specialites=this.specialitesmedecinspecialiste
    }
   
    else{
      this.specialites=[]
      this.sousspecialites=[]

    }
    this.userForm.patchValue({
      specialite: '',
      sousspecialite: '',
    })
  }
  update3(e)
  {
  }
  sort()
  {
    this.specialites.sort()
    this.sousactivites.sort()
    this.activites.sort()
  }
  onImagePick(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    console.log(file);
    this.userForm.get('image').patchValue(file);
    this.userForm.get('image').updateValueAndValidity();
    const reader = new FileReader();
    reader.onload = () => {
      if (this.userForm.get('image').valid) {
        this.imagePreview = reader.result as string;
      } else {
        this.imagePreview = null;
      }
    };
    reader.readAsDataURL(file);
  }*/
  reloadPage (){
    setTimeout(() => window.location.reload(), 3000);
    
    
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  
}
